import { FC, ReactNode } from 'react';
import { css } from '@emotion/react';
import { useHistory } from 'react-router-dom';
import { colors, spacing } from '../../../styles';

interface Props {
  text: ReactNode;
  isLatest?: boolean;
  textLength?: number;
}

const Dot: FC<{ isFilled?: boolean }> = ({ isFilled }) => (
  <span
    css={css`
      height: 10px;
      width: 10px;
      border-radius: 50%;
      display: inline-block;
      background-color: ${isFilled ? colors.petrolBlue : 'transparent'};
      border: solid 2px ${colors.petrolBlue};
      position: relative;
      top: 1px;
    `}
  />
);

const getFontSize = (length: number): string => {
  if (length < 60) return '14px';
  if (length < 100) return '13px';
  if (length < 160) return '12px';
  if (length < 250) return '11px';
  return '10px';
};

const Wiim: FC<Props> = ({ text, isLatest, textLength = 0 }) => {
  const history = useHistory();
  const isClickable = typeof text === 'string';
  const fontSize = getFontSize(textLength);

  const handleClick = (e: React.MouseEvent | React.TouchEvent) => {
    e.stopPropagation();
    e.preventDefault();
    if (isClickable) {
      history.push('/chat', { message: `Tell me more: ${text}` });
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && isClickable) {
      history.push('/chat', { message: `Tell me more: ${text}` });
    }
  };

  return (
    <div
      onClick={isClickable ? handleClick : undefined}
      onTouchEnd={isClickable ? handleClick : undefined}
      onKeyDown={isClickable ? handleKeyDown : undefined}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
      css={
        isClickable
          ? css`
              cursor: pointer;
              -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
              &:hover {
                opacity: 0.8;
              }
            `
          : undefined
      }
    >
      <p
        css={css`
          margin: 0;
          color: ${colors.silver};
          font-size: ${fontSize};
          line-height: 1.4;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          html[data-theme='dark'] & {
            color: ${colors.sugar};
          }
        `}
      >
        <span
          css={css`
            margin-right: ${spacing.centi};
          `}
        >
          {isLatest ? <Dot /> : <Dot isFilled />}
        </span>
        {text}
      </p>
    </div>
  );
};

export default Wiim;
